import React from "react";
import { cn } from "../../lib/cn";

export interface FormFieldProps {
  label?: React.ReactNode;
  htmlFor?: string;
  required?: boolean;
  optional?: boolean;
  helper?: React.ReactNode;
  error?: string | false | null;
  className?: string;
  children: React.ReactNode;
}

const labelCls = "block mb-[9px] text-[12px] font-semibold tracking-[0.02em] text-muted";
const optCls = "text-faint font-medium";

/**
 * Field wrapper: label (+ optional/required marker) over a control slot, with an
 * inline helper or error line beneath. Framework-agnostic — pass `error` from
 * useState or Formik `touched && errors[name]`.
 */
export const FormField: React.FC<FormFieldProps> = ({
  label,
  htmlFor,
  required,
  optional,
  helper,
  error,
  className,
  children,
}) => (
  <div className={cn("w-full", className)}>
    {label && (
      <label className={labelCls} htmlFor={htmlFor}>
        {label}
        {required && <span className="text-danger"> *</span>}
        {optional && <span className={cn("ml-1", optCls)}>(optional)</span>}
      </label>
    )}
    {children}
    {error ? (
      <p className="mt-[6px] text-[12px] text-danger">{error}</p>
    ) : helper ? (
      <p className="mt-[6px] text-[12px] text-faint">{helper}</p>
    ) : null}
  </div>
);

export default FormField;
